<template>
  <section>
    <div class="wrapper">
      <input :id="name" class="exp" type="checkbox" />
      <div :class="['text', { 'dark-text': darkText },{'hide-shadow':!btnshow}]" ref='text'>
        <label class="btn" :for="name" ref="btn" v-if="btnshow"></label>
        <div v-html="content"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    darkText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: 'exp1' + Math.random(),
      btnshow: false
    }
  },
  watch: {
    content (newVal) {
      this.judgeShow()
    }
  },
  created () {
    this.judgeShow()
  },
  methods: {
    judgeShow () {
      this.$nextTick(() => {
        if (this.$refs.text.clientHeight <= 105) { // line-height  21 * 3 行
          // if(this.$refs.text.clientHeight <= 63){ //line-height  21 * 3 行
          // this.$refs.btn.style.display = 'none'
          this.btnshow = false
        } else {
          this.$refs.text.style.maxHeight = '7.5em' // line-height 1.5  * 3 行
          // this.$refs.text.style.maxHeight = '4.5em'  //line-height 1.5  * 3 行
          this.btnshow = true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  // margin: 50px auto;
  // width: 800px;
  overflow: hidden;
  /*   resize: horizontal; */
  // border-radius: 8px;
  // padding: 15px;
  // box-shadow: 20px 20px 60px #bebebe, -20px -20px 60px #ffffff;
}
.text {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  color: #070707;
  /* display: flex; */
  /*   display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical; */
  position: relative;
  line-height: 1.5;
  // max-height: 4.5em;
  transition: 0.3s max-height;
}
.hide-shadow::after {
  display: none;
}
.text::before {
  content: '';
  height: calc(100% - 20px);
  float: right;
}
.text::after {
  content: '';
  width: 999vw;
  height: 999vw;
  position: absolute;
  box-shadow: inset calc(95px - 999vw) calc(25px - 999vw) 0 0 #f7f9fc;
  margin-left: -100px;
}
.dark-text {
  color: #070707;
}
.dark-text::after {
  box-shadow: inset calc(95px - 999vw) calc(25px - 999vw) 0 0 #eceff3;
}
.btn {
  position: relative;
  float: right;
  clear: both;
  margin-left: 20px;
  font-size: 14px;
  padding: 0 8px;
  line-height: 20px;
  border-radius: 2px;
  color: #076ffd;
  cursor: pointer;
  /* margin-top: -30px; */
}
.btn::after {
  content: '展开';
}
.exp {
  display: none;
}
.exp:checked + .text {
  max-height: none !important;
}
.exp:checked + .text::after {
  visibility: hidden;
}
.exp:checked + .text .btn::before {
  visibility: hidden;
}
.exp:checked + .text .btn::after {
  content: '收起';
}
.btn::before {
  content: '...';
  position: absolute;
  left: -5px;
  color: #333;
  transform: translateX(-100%);
}
.dark {
  section {
    :deep(.wrapper) {
      .text {
        color: #d8d8df;
      }
      .dark-text {
        color: #d8d8df;
      }
      .text::after {
        box-shadow: inset calc(95px - 999vw) calc(25px - 999vw) 0 0 #1b1b1b;
      }
      .dark-text::after {
        box-shadow: inset calc(95px - 999vw) calc(25px - 999vw) 0 0 #292f40;
      }
      .btn::before {
        color: #d8d8df;
      }
    }
  }
}
</style>
